// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-image-style[data-v-63a8e954]{width:50px;height:50px;-o-object-fit:scale-down;object-fit:scale-down;padding-bottom:7px}.content-box[data-v-63a8e954]{text-align:center;margin:60px 25px 25px 25px}.bottom-bar[data-v-63a8e954]{background-color:#4abca5;border-top-style:solid;border-top-color:#837d89;border-top-width:5px}", ""]);
// Exports
module.exports = exports;
